export const CERTIFICATE_VALUES_MIN_COLS = 3;
